export default __webpack_public_path__ + "static/media/cachorro-gato2@2x.3e828f16.jpg";